import React, {
  useEffect,
  useState,
} from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  FaCalendarAlt,
} from "react-icons/fa";

const EventPage = () => {
  const [events, setEvents] =
    useState([]);

  const [open, setOpen] =
    useState(false);

  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/events"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setEvents(
          Array.isArray(data)
            ? data
            : []
        )
      )
      .catch((err) =>
        console.log(
          "Event fetch error:",
          err
        )
      );
  }, []);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#072F5F] via-[#0B4F9C] to-[#072F5F] py-20 md:py-28">

        {/* DESIGN */}
        <div className="absolute inset-0 opacity-10">

          <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full blur-3xl"></div>

          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4A017] rounded-full blur-3xl"></div>

        </div>

        <div className="relative max-w-7xl mx-auto px-5 md:px-10 text-center">

          <div className="w-20 h-20 rounded-3xl bg-white/10 backdrop-blur-md flex items-center justify-center text-white text-3xl mx-auto shadow-2xl">

            <FaCalendarAlt />

          </div>

          <span className="inline-block mt-6 text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

            School Activities

          </span>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white mt-5">

            SCHOOL EVENTS

          </h1>

          <p className="text-gray-200 text-lg mt-6 max-w-3xl mx-auto leading-8">

            Celebrating excellence, creativity,
            achievements and memorable moments
            at Nav Jeevan Mission School.

          </p>

        </div>

      </section>

      {/* EVENTS SECTION */}
      <section className="w-full bg-[#f7f9fc] py-16 md:py-24 overflow-x-hidden">

        <div className="max-w-7xl mx-auto px-5 md:px-10">

          {/* HEADING */}
          <div className="text-center mb-16">

            <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

              Events & Celebrations

            </span>

            <h2 className="text-4xl md:text-5xl font-extrabold text-[#072F5F] mt-4">

              Latest School Events

            </h2>

            <div className="w-24 h-1 bg-[#D4A017] rounded-full mx-auto mt-6"></div>

          </div>

          {/* GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">

            {events.length > 0 ? (
              events.map((e) => (
                <div
                  key={e.id}
                  className="group bg-white rounded-[30px] overflow-hidden shadow-lg border border-gray-100 hover:-translate-y-2 hover:shadow-2xl transition-all duration-500"
                >

                  {/* IMAGE */}
                  <div className="relative overflow-hidden">

                    <img
                      src={`https://stjosephweb.ilakshyaerp.in/uploads/events/${e.image}`}
                      alt="event"
                      className="w-full h-[280px] object-cover group-hover:scale-110 transition-all duration-700"
                    />

                    {/* OVERLAY */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                  </div>

                  {/* CONTENT */}
                  <div className="p-7">

                    <h3 className="text-2xl font-extrabold text-[#072F5F] leading-snug line-clamp-4">

                      {e.narration}

                    </h3>

                    <div className="w-14 h-[3px] bg-[#D4A017] rounded-full mt-5"></div>

                  </div>

                </div>
              ))
            ) : (
              <div className="col-span-full">

                <div className="bg-white rounded-[30px] shadow-lg border border-gray-100 p-16 text-center">

                  <div className="w-20 h-20 rounded-full bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-3xl mx-auto mb-6">

                    <FaCalendarAlt />

                  </div>

                  <h3 className="text-3xl font-extrabold text-[#072F5F]">

                    No Events Available

                  </h3>

                  <p className="text-gray-500 mt-4 text-lg">

                    Upcoming school events will appear here soon.

                  </p>

                </div>

              </div>
            )}

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default EventPage;